<script setup>

import StaticWidget from "@/components/common/other/StaticWidget"
import Shipments from "@/components/shipments/Shipments"
import SlideInDrawer from "@/components/common/navigation/SlideInDrawer";
import ShipmentDocumentDownload from "@/components/shipments/ShipmentDocumentDownload";

import {useStore} from 'vuex';
import {inject, onMounted, ref} from 'vue'

const shipments = inject("shipments");
const store = useStore();

let tabDataModelReady = ref(false);

onMounted(() => {

  mapTabSelections()
})

function mapTabSelections() {

  shipments.value.activeShipmentTabs.air.active = store.state.userSettings.showShipmentsTabSettings.air;
  shipments.value.activeShipmentTabs.road.active = store.state.userSettings.showShipmentsTabSettings.road;
  shipments.value.activeShipmentTabs.sea.active = store.state.userSettings.showShipmentsTabSettings.sea;
  shipments.value.activeShipmentTabs.rail.active = store.state.userSettings.showShipmentsTabSettings.rail;
  shipments.value.activeShipmentTabs.courier.active = store.state.userSettings.showShipmentsTabSettings.courier;
  shipments.value.activeShipmentTabs.other.active = store.state.userSettings.showShipmentsTabSettings.other;

  tabDataModelReady.value = true;

}

</script>

<template id="cmp-show-shipments" class="view-show-shipments">
  <SlideInDrawer
      :height="218"
      title="Available Documents"
      v-model:open-drawer="shipments.shipmentDocsDrawer">
    <template #icon><i class="fa-solid fa-folder-open" style="color: #eab410;"></i></template>
    <ShipmentDocumentDownload></ShipmentDocumentDownload>
  </SlideInDrawer>
  <StaticWidget
      height="735"
      title="Shipments For All Modes">
    <Shipments v-if="tabDataModelReady"></Shipments>
  </StaticWidget>
</template>

<style lang="scss" scoped>

</style>
